export default "__VITE_ASSET__DpCuOfi6__"